import _ from 'lodash';
import { SESSION_TIMEOUT_SECONDS } from '../common/config';
import I18n from '../../config/i18n';
import monarch from '../common/clients/monarch';
import { handleAppError } from './app';
import { isSessionExpired } from './isSessionExpired';

const initialState = [];
const RECEIVE = 'countries/RECEIVE';

export function receiveCountries(countries) {
  return { type: RECEIVE, payload: countries };
}

function formatCountry(country) {
  country.intlCode = `+${country.intlCode}`;
  return country;
}

export function loadCountries() {
  let Countries = sessionStorage.getItem('Countries');
  let isExpired = isSessionExpired(SESSION_TIMEOUT_SECONDS, 'countries');
  if (!Countries || isExpired) {
    return (dispatch) => {
      return monarch
        .get('/v1/countries')
        .then((res) => _.sortBy(res.data, 'intlCode'))
        .then((countries) => countries.map((country) => formatCountry(country)))
        .then((countries) => {
          sessionStorage.setItem('Countries', JSON.stringify(countries));
          dispatch(receiveCountries(countries));
        })
        .catch((error) =>
          dispatch(handleAppError(error, I18n.t('unexpectedError'))),
        );
    };
  } else {
    return (dispatch) => {
      dispatch(receiveCountries(JSON.parse(Countries)));
    };
  }
}

export default function reducer(state = initialState, action) {
  let { type, payload } = action;
  switch (type) {
    case RECEIVE:
      return payload;

    default:
      return state;
  }
}
